module.exports = __webpack_public_path__ + "static/assets/7679e8aa3b5a6b745823e00a7b950065.png";